import axios from '@/utils/axios'
// 总列表
export function totallist(query) {
    return axios({
        url: '/novelPostbackRecord/getTotalList',
        method: 'get',
        params: query
    })
}
// //详情列表
// export function list(query) {
//     return axios({
//         url: '/stat/adUnlockLog/getList',
//         method: 'get',
//         params: query
//     })
// }
// // 补回传
// export function addRepair(query) {
//     return axios({
//         url: '/stat/adUnlockLog/addRepair',
//         method: 'get',
//         params: query
//     })
// }

//付费补回传列表
export function rechargeList(query) {
    return axios({
        url: '/novelPostbackRecord/getList',
        method: 'get',
        params: query
    })
}

// 补回传
export function addRechargeRepair(query) {
    return axios({
        url: '/novelPostbackRecord/sinaReplenishCallBack',
        method: 'get',
        params: query
    })
}